/** The id of Moo, the general assistant. */
export const DEFAULT_MOO_ID = 'default-moo';

/**
 * Cowbell's agents in policy-lifecycle order: intake, risk assessment,
 * underwriting, servicing, renewal, claims, then the agents that read across
 * the whole book (production health, market intelligence). Keyed by id, which
 * is stable where names are not.
 */
export const LIFECYCLE_ORDER: readonly string[] = [
  'submissions',
  'risk-engineering-agent',
  'underwriter',
  'cyber-underwriter',
  'ml-underwriter',
  'tech-eo-underwriter',
  'concierge',
  'renewals',
  'claimsense',
  'pulse',
  'cyber-pulse',
];

/**
 * Moo first, then the lifecycle order above. Agents it does not list (new
 * system agents, custom agents) follow in the order they arrived.
 */
export function sortAgentsByLifecycle<T extends { readonly id: string }>(
  agents: readonly T[]
): T[] {
  const rank = (agent: T): number => {
    if (agent.id === DEFAULT_MOO_ID) return -1;
    const index = LIFECYCLE_ORDER.indexOf(agent.id);
    return index === -1 ? LIFECYCLE_ORDER.length : index;
  };
  // Array.prototype.sort is stable, so unlisted agents keep their order.
  return [...agents].sort((a, b) => rank(a) - rank(b));
}
